// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"62b10807","87":"e9682c5f","104":"b2cfa31a","111":"20b612e3","182":"6f6161d0","323":"ff8b7d8e","445":"658f5352","453":"f993d5f1","585":"50be4906","605":"8471a87f","612":"e1979d6a","767":"da235419","870":"06c06014"}[chunkId] + ".chunk.js";
};